export const __DEV__ = process.env.NODE_ENV !== 'production';

export const SERVICE_NAME = 'pharmacy-web';
